import { z } from "zod";

// Skema untuk satu item data dalam laporan penjualan V4
const SalesReportDataV4Schema = z.object({
    property_name: z.string(),
    booking_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
    source: z.string(),
    reservation_number: z.string(),
    guest_name: z.string(),
    checkin_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
    checkout_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
    extra: z.string().transform(val => parseFloat(val)),
    amount: z.string().transform(val => parseFloat(val)),
});

// Skema untuk objek 'total' dalam respons V4
const SalesReportTotalV4Schema = z.object({
    extra: z.string().transform(val => parseFloat(val)),
    amount: z.string().transform(val => parseFloat(val)),
});

// Skema utama untuk keseluruhan respons API V4
export const SalesReportResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(SalesReportDataV4Schema),
    total: SalesReportTotalV4Schema,
});

// Ekspor tipe TypeScript yang diambil dari skema Zod
export type SalesReportResponseV4 = z.infer<typeof SalesReportResponseV4Schema>;
export type SalesReportDataV4 = z.infer<typeof SalesReportDataV4Schema>;